import React, { useState } from "react";
import { motion } from "framer-motion";
import { resolveImg } from "@/lib/api";

export default function Categories({ categories = {} }) {
  const items = categories.items || [];
  const [hovered, setHovered] = useState(null);

  return (
    <section
      id="cardapio"
      data-testid="categories-section"
      className="relative bg-stone-950 py-14 md:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-12">
          <div>
            <motion.span
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="text-xs tracking-[0.3em] uppercase text-amber-500 font-semibold"
            >
              {categories.label || "Cardápio"}
            </motion.span>
            <motion.h2
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.1, duration: 0.8 }}
              className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-stone-50 mt-4"
            >
              Nossas Categorias
            </motion.h2>
          </div>
          <p className="max-w-sm text-stone-400 md:text-right leading-relaxed">
            Explore nossas seleções preparadas diariamente com ingredientes frescos e cuidado artesanal.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {items.map((cat, i) => (
            <motion.div
              key={cat.id || i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.08, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              data-testid={`category-card-${i}`}
              className="group relative"
            >
              <div className="relative aspect-square overflow-hidden bg-stone-900">
                <img
                  src={resolveImg(cat.image)}
                  alt={cat.title}
                  className={`h-full w-full object-cover transition-[transform,opacity] duration-700 group-hover:scale-105 ${
                    hovered !== null && hovered !== i ? "opacity-40" : "opacity-100"
                  }`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-stone-950/90 via-transparent to-transparent" />
                <div className="absolute inset-x-0 bottom-0 p-5">
                  <h3 className="font-serif text-xl md:text-2xl text-stone-50">{cat.title}</h3>
                  <p className="text-xs text-stone-300 mt-1">{cat.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
